function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2404",
  "data-name": "Group 2404",
  transform: "translate(0.166 0.174)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237",
  transform: "translate(1.38 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  transform: "translate(2.727)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M-2058.76,5.873h-1.452v-.2a1.15,1.15,0,0,0-1.146-1.152h-.027a1.149,1.149,0,0,0-1.145,1.152v.2h-1.452a.137.137,0,0,0-.136.136V7.476a.137.137,0,0,0,.136.136h5.223a.137.137,0,0,0,.136-.136V6.009A.137.137,0,0,0-2058.76,5.873Zm-2.611-.9a.381.381,0,0,1,.383.382.381.381,0,0,1-.383.382.381.381,0,0,1-.382-.382A.381.381,0,0,1-2061.371,4.973Z",
  transform: "translate(2064.119 -4.516)",
  fill: "rgba(0,205,152,0.75)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M-2058.4,8.076h-.675v.873a.672.672,0,0,1-.675.674h-5.8a.672.672,0,0,1-.675-.674V8.076h-.7a1.2,1.2,0,0,0-1.207,1.207v8.509A1.2,1.2,0,0,0-2066.912,19h8.516a1.2,1.2,0,0,0,1.2-1.207V9.283A1.2,1.2,0,0,0-2058.4,8.076Zm-7.956,3.764h4.656a.608.608,0,0,1,.607.607.609.609,0,0,1-.607.607h-4.656a.611.611,0,0,1-.615-.607A.61.61,0,0,1-2066.352,11.84Zm7.424,3.942h-7.424a.611.611,0,0,1-.615-.607.61.61,0,0,1,.615-.607h7.424a.608.608,0,0,1,.607.607A.609.609,0,0,1-2058.928,15.781Z",
  transform: "translate(2068.119 -5.649)",
  fill: "rgba(0,205,152,0.75)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_116",
  "data-name": "Rectangle 116",
  width: 14,
  height: 14,
  transform: "translate(-0.166 -0.174)",
  fill: "none"
}));

var SvgExam = function SvgExam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exam.d37089b9.svg";
export { ForwardRef as ReactComponent };